import { mapActions } from 'vuex';
import domainMixin from '../../../mixins/domain';

export default {
  mixins: [domainMixin],
  components: {},
  data() {
    return {
      ruleForm: {
        password: '',
      },
      loading: false,
      rules: {
        password: [
          { required: true, message: "Новий пароль є обов'язковим" },
          {
            required: true,
            min: 6,
            message: 'Довжина паролю повина бути від 3 до 8 символів',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['updatePassword']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.ruleForm.token = this.$route.params.token;
          this.updatePassword(this.ruleForm)
            .then((result) => {
              this.$notify.success({
                title: 'Вітаємо!',
                message: result.data,
                duration: 2000,
                onClose: () => {
                  this.$router.push('/login');
                }
              });
              this.loading = false;
            })
            .catch(() => {
              this.$notify.error({
                title: 'Помилка',
                message: 'Час сесії відновлення паролю вичерпано спробуйте відновити пароль ще раз.',
              });
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
